import { render, staticRenderFns } from "./LayoutAppBarVerticalNav.vue?vue&type=template&id=edd0b282&scoped=true"
import script from "./LayoutAppBarVerticalNav.vue?vue&type=script&lang=js"
export * from "./LayoutAppBarVerticalNav.vue?vue&type=script&lang=js"
import style0 from "./LayoutAppBarVerticalNav.vue?vue&type=style&index=0&id=edd0b282&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "edd0b282",
  null
  
)

export default component.exports